import EmailConfigComponent from '../Components/SystemConfiguration/EmailConfigComponent';

function SystemConfigurationEmailPage() {
  return <EmailConfigComponent />;
}

export default SystemConfigurationEmailPage;
